import { createFileRoute } from "@tanstack/react-router";
import { m } from "~/lib/i18n";

export const Route = createFileRoute("/_app/referrals")({
  head: () => ({
    meta: [
      { title: m.referrals_page_meta_title() },
      {
        content: m.referrals_page_meta_description(),
        name: "description",
      },
    ],
  }),
  loader: ({ context }) => {
    void import("~/features/referrals/referrals-route").then(
      ({ preloadReferralsRoute }) => {
        void preloadReferralsRoute(context);
      },
    );
  },
});
